import * as React from "react";
import type { SVGProps } from "react";
const SvgContinuousdrawingIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={16}
    height={16}
    className="continuousdrawing_icon_svg__icon"
    viewBox="0 0 1024 1024"
    {...props}
  >
    <path
      fill="currentColor"
      d="M895.936 85.312h-512A42.688 42.688 0 0 0 341.248 128v170.688h-85.312a42.688 42.688 0 0 0-42.688 42.688V512h-85.312a42.688 42.688 0 0 0-42.688 42.688V896a42.688 42.688 0 0 0 42.688 42.688h341.312A42.688 42.688 0 0 0 511.936 896v-85.312H682.56A42.688 42.688 0 0 0 725.248 768v-85.312h170.688A42.688 42.688 0 0 0 938.56 640V128A42.688 42.688 0 0 0 896 85.312zm-469.376 768h-256v-256h256v256zm213.376-128h-128v-170.56A42.688 42.688 0 0 0 469.248 512H298.56V384H640v341.376zm213.312-128h-128v-256a42.688 42.688 0 0 0-42.688-42.624h-256v-128h426.688v426.688z"
    />
  </svg>
);
export default SvgContinuousdrawingIcon;
